import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import pruef_PlanConstants from "../Constants/Pruef_PlanConstants";
class PruefPlanActions {
  getPruefGroup() {
    httpRequest(
      config.webServiceURL + "/PruefGroup/GePruefGroups",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefGroup_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefGroup_FAILURE,
          });
        }
      }
    );
  }
  saveUpdatePruefGroup(pruepGroupData) {
    httpRequest(
      config.webServiceURL + "/PruefGroup/SaveUpdatePruefGroup",
      "POST",
      JSON.stringify({
        ID: pruepGroupData.ID,
        Bezeichnung: pruepGroupData.Bezeichnung,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  deletePruefGroup(pruefGRoupIds) {
    httpRequest(
      config.webServiceURL + "/PruefGroup/Delete",
      "DELETE",
      JSON.stringify([...pruefGRoupIds]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_PruefGroup_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_PruefGroup_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getPruefPlan(egId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/Get/" + egId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefPlan_FAILURE,
          });
        }
      }
    );
  }
  getActivePruefPlan(egId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/GetActivePruefPlans/" + egId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_ActivePruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_ActivePruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getKostPruefGroups(egId) {
    httpRequest(
      config.webServiceURL + "/Checklist/GetKostPruefGroups/" + egId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_KostPruefGroups_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_KostPruefGroups_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  saveUpdateChecklist(pruefPlanData, isPublish) {
    let url = isPublish
      ? "/checklist/SaveUpdateChecklist?IsPublish=" + true
      : "/checklist/SaveUpdateChecklist";
    httpRequest(
      config.webServiceURL + url,
      "POST",
      JSON.stringify(pruefPlanData),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getPruefPlanQuestion(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/GetPruefPlanQuestions/" + pruefPlanId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefPlanQuestion_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_PruefPlanQuestion_FAILURE,
          });
        }
      }
    );
  }
  saveUpdatePruefPlanQuestion(pruefPlanQuestionData) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/SaveUpdatePruefPlanQuestions",
      "POST",
      JSON.stringify({
        PruefPlanId: pruefPlanQuestionData.PruefPlanId,
        Questions: pruefPlanQuestionData.Questions,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefPlanQuestion_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_PruefPlanQuestion_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  copyPruefPlan(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/CopyPruefPlan/" + pruefPlanId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.COPY_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.COPY_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  deletePruefPlan(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/DeletePruefPlan/" + pruefPlanId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getPruefPlanEquipment(analageid) {
    httpRequest(
      config.webServiceURL +
        "/AuftragManagement/GetAuftragforAnlage/" +
        analageid,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_Equipment_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_Equipment_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  saveUpdateSinglePruefPlan(pruefPlanData) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/SaveUpdateAuftrag",
      "POST",
      JSON.stringify({
        Id: pruefPlanData.Id,
        AnlageId: pruefPlanData.AnlageId,
        Beschreibung: pruefPlanData.Beschreibung,
        Turnus: pruefPlanData.Turnus,
        TurnusZyklus: pruefPlanData.TurnusZyklus,
        BestelltNr: pruefPlanData.BestelltNr,
        Kurzbezeichnung: pruefPlanData.Kurzbezeichnung,
        AuftragsNr: pruefPlanData.AuftragsNr,
        PruefFragenrueckmeldungsModels:
          pruefPlanData.PruefFragenrueckmeldungsModels,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_Equipment_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ADDORUPDATE_Equipment_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  deleteSinglePruefPlan(auftragId) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/DeleteAuftrag/" + auftragId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_Equipment_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_Equipment_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  publishPruefPlan(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/Publish/" + pruefPlanId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.PUBLISH_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.PUBLISH_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  disablePruefPlan(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/Disable/" + pruefPlanId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DEACTIVATE_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DEACTIVATE_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  enablePruefPlan(pruefPlanId) {
    httpRequest(
      config.webServiceURL + "/PruefPlan/Enable/" + pruefPlanId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ACTIVATE_PruefPlan_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.ACTIVATE_PruefPlan_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getChecklist() {
    httpRequest(
      config.webServiceURL + "/Checklist/GetActiveCheckLists",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getChecklistDetails(checklistId) {
    httpRequest(
      config.webServiceURL + "/Checklist/GetChecklist/" + checklistId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  publishChecklist(checklistId) {
    httpRequest(
      config.webServiceURL + "/Checklist/Publish/" + checklistId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.PUBLISH_CHECKLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.PUBLISH_CHECKLIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getChecklistByEquGrpId(equipmentGrpID) {
    httpRequest(
      config.webServiceURL +
        "/Checklist/GetEquipmentgroupCheckLists/" +
        equipmentGrpID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deActivateChecklist(checklistId) {
    httpRequest(
      config.webServiceURL + "/Checklist/DeactivateChecklist/" + checklistId,
      "PATCH",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DEACTIVATE_CHECKLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DEACTIVATE_CHECKLIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteChecklist(checklistId) {
    httpRequest(
      config.webServiceURL + "/Checklist/DeleteChecklist/" + checklistId,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_CHECKLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_CHECKLIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  SaveChecklistAsTemplate(pruefPlanData) {
    httpRequest(
      config.webServiceURL + "/Checklist/SaveChecklistAsTemplate",
      "POST",
      JSON.stringify(pruefPlanData),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getChecklistTemplates() {
    httpRequest(
      config.webServiceURL + "/Checklist/GetChecklistTemplates",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteChecklistTemplate(checklistTemplateIds) {
    httpRequest(
      config.webServiceURL + "/Checklist/DeleteChecklistTemplate",
      "DELETE",
      JSON.stringify([...checklistTemplateIds]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new PruefPlanActions();
